export const USER_URLS = {
  GET_ALL_USER: '/user/all',
  GET_ALL_ROLE: '/role',
  CREATE_USER: '/user/createUser',
  GET_SINGLE_USER: '/user/getUserbyid',
  UPDATE_USER: '/user/updateUser',
  GET_ALL_FEDERAL_STATE: '/states'
};
